function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getBackgroundToken, getTextToken } from "../fundations/palette/colorTokens";
export const Tooltip = {
    MuiTooltip: {
        defaultProps: {
            arrow: true
        },
        styleOverrides: {
            tooltip: ({ theme })=>_object_spread({
                    backgroundColor: getBackgroundToken("layerOnBackground1", theme),
                    color: getTextToken("textSecondary", theme),
                    padding: theme.spacing(0.5, 1.25),
                    boxShadow: theme.shadows[3],
                    fontWeight: 500
                }, theme.typography.textXs),
            arrow: ({ theme })=>({
                    color: getBackgroundToken("layerOnBackground1", theme)
                })
        }
    }
};

//# sourceMappingURL=Tooltip.js.map